import { render, staticRenderFns } from "./Traces.vue?vue&type=template&id=1fb356a8&scoped=true"
import script from "./Traces.vue?vue&type=script&lang=js"
export * from "./Traces.vue?vue&type=script&lang=js"
import style0 from "./Traces.vue?vue&type=style&index=0&id=1fb356a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fb356a8",
  null
  
)

export default component.exports